/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useState } from "react"
import { motion } from 'framer-motion'
import { useNavigate, useSearchParams } from "react-router-dom"
import { handleSidebarAnimation } from "../../../redux/commonSlice"
import TopHeader from "../../../components/TopHeader"

import HistoricalData from "./Component/DeviceReadingHistory/Components"
import { useDispatch } from "react-redux"
import Graphs from "./Component/Graphs"
import { dataService } from "../../../services/data.services"
import { usersList, useViewGraphPatientQuery } from "../../../features/apiSlice"
import moment from "moment"
import { useGetPatientWellnessDetailsQuery } from "../../../features/patientSlice"
import CustomOverLay from "../../../components/CustomOverLay"
import GlobalContext from "../../../components/Context/GloablContext"
import Emptyscreenwithouttitle from "../../../components/Emptyscreenwithouttitle"


export default function Dashboard() {
    const [dashBoardTabName, setDashBoardTabName] = useState('graph')
    const { isSideBar } = useContext(GlobalContext)
    const [graphDetails, setGraphDetails] = useState([])
    const { data: patientData, status: patientstatus } = useViewGraphPatientQuery();
    const { data: wellnessDetails, isFetching, status } = useGetPatientWellnessDetailsQuery()
    const [graphLoader, setGraphLoader] = useState(false)
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [filterDate, setFilterDate] = useState(null); // State to hold the filtered date
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const [stateLoading, setStateLoading] = useState(false)
    // const {data,isFetching,status}=useViewPatientQuery({refetchOnMountOrArgChange: true})
    var currentTimeInMillisUTC = Date.now();

    // Convert milliseconds to seconds (divide by 1000)
    var currentTimeInSeconds = Math.floor(currentTimeInMillisUTC / 1000);

    // Display the current time in epoch format in UTC
    const navigate = useNavigate()

    const handleTabChange = (tabName) => {
        setDashBoardTabName(tabName)
        if (searchParams.get('tabname') !== 'graph') {
            if (tabName === 'graph' && patientData !== undefined) {
                handleFetchGraphDetials(patientData?.[0]?.patient_id)
            }
        }

    }
    function sendDateToAPI(epochDate) {
        // Here, you can send the epochDate to your API
        // Add your API call logic here
    }

    const [isSafari, setIsSafari] = useState(false);
    useEffect(() => {
        if (searchParams?.get('tabname') === 'historical_data') {
            handleTabChange('historical_data')
        } else {
            handleTabChange('graph')
        }
        setIsSafari(/^((?!chrome|firefox|android).)*safari/i.test(navigator.userAgent));
    }, []);

    const handleSelectDate = (id, date, dateString, termkey) => {

        setSelectedDate(dateString)
        setFilterDate(dateString);
    }

    const previousDay = () => {
        const date = filterDate ? new Date(filterDate) : selectedDate === '' ? new Date() : new Date(selectedDate); // If filterDate exists, use it, else use current date
        date.setDate(date.getDate() - 1); // Subtract 1 day
        const epochDate = Math.floor(date.getTime() / 1000);
        sendDateToAPI(epochDate);
        setSelectedDate(epochDate)
        if (filterDate) {
            setFilterDate(date.toISOString().slice(0, 10)); // Update filterDate state if filterDate exists
        }
        setSelectedDate(date.toISOString().slice(0, 10))
    };

    // Function to handle next day
    const nextDay = () => {
        const date = filterDate ? new Date(filterDate) : selectedDate === '' ? new Date() : new Date(selectedDate); // If filterDate exists, use it, else use current date
        date.setDate(date.getDate() + 1); // Add 1 day
        const epochDate = Math.floor(date.getTime() / 1000);
        sendDateToAPI(epochDate);
        if (filterDate) {
            setFilterDate(date.toISOString().slice(0, 10)); // Update filterDate state if filterDate exists
        }
        setSelectedDate(date.toISOString().slice(0, 10))
    };


    const handleFetchGraphDetials = useCallback(async (patientId) => {
        setGraphLoader(true)
        let endpoint
        if (selectedDate !== '') {
            endpoint = `api-listener/patient/${patientId}?filter=true&day=${moment(selectedDate).format('YYYY-MM-DD')}&current_date=${currentTimeInSeconds}`
        } else {
            endpoint = `api-listener/patient/${patientId}?filter=false&day=${currentTimeInSeconds}`
        }
        try {
            const response = await dataService.GetAPI(endpoint)
            if (response.error === false) {
                setGraphDetails(response.data.data)
                setGraphLoader(false)
            } else {
                setGraphLoader(false)
            }
        } catch (e) {
            setGraphLoader(false)
        }

    }, [selectedDate]); // handleSelectDate is added as a dependency

    const handleTodayClick = () => {
        const today = moment();
        setSelectedDate(today);
    };

    useEffect(() => {
        patientData !== undefined && handleFetchGraphDetials(patientData?.[0]?.patient_id)
    }, [handleFetchGraphDetials, selectedDate, patientData]);


    return (
        <>
            <div id={"patient_main_div"} className='bg-[#F9F3F5] pt-[65px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Dashboard"} />
                <div className='py-[35px] px-[30px] h-customh3'>
                    <motion.div
                        className="mt-1"
                        animate={{ x: 0 }}
                        initial={{ x: -10 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className=''>
                            <div className="flex justify-between items-center h-12">
                                <div className={`flex justify-start ${isSafari ? 'pb-4' : 'pb-2'} overflow-x-auto overflow-y-hidden ${isSafari ? 'scrollbar_purple' : 'scrollBar-hidden'} border-b border-[#E7CBD2] w-full mr-6`}>
                                    <button 
                                    disabled={stateLoading}
                                    onClick={() => { handleTabChange('graph'); setSearchParams('tabname=graph') }}
                                     className={`px-2.5 pt-2.5 min-w-fit text-base font-semibold ${dashBoardTabName === 'graph' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${dashBoardTabName === 'graph' ? 'patient_tab' : ''}`}
                                     >
                                        Graphs
                                    </button>
                                    <button 
                                    disabled={stateLoading ||isFetching || searchParams?.get('tabname') === 'historical_data'}
                                     id={'historical_data'} 
                                     data-testid={'historical_data'} 
                                     onClick={() => { handleTabChange('historical_data'); setSearchParams('tabname=historical_data') }} 
                                     className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${dashBoardTabName === 'historical_data' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${dashBoardTabName === 'historical_data' ? 'patient_tab' : ''}`}
                                     >
                                        Historical Data
                                    </button>
                                </div>
                                {!isFetching && patientData !== undefined &&
                                    <button type="button" id="view_details"
                                        onClick={() => {
                                            dispatch(usersList.util.resetApiState());
                                            navigate(`/dashboard/view-details/${patientData?.[0]?._id}`); dispatch(handleSidebarAnimation(false))
                                        }}
                                        className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                    focus:bg-[#863B50] disabled:bg-[#777C88] xl:ml-4 ml-2`}>
                                        View Details
                                    </button>
                                }
                            </div>
                            {dashBoardTabName === 'graph' &&
                                (isFetching ||
                                    ((patientstatus !== 'fulfilled' && status !== 'fulfilled') &&
                                        (patientstatus !== 'rejected' && status !== 'rejected'))) ? (
                                <div className="mt-10">
                                    <CustomOverLay
                                        Active
                                        text="Loading Graph Details..."
                                        classKey={`top-0 left-0 right-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_overlay' : 'overlay-list1'}`}
                                    />
                                </div>
                            ) : (
                                dashBoardTabName === 'graph' && !isFetching && (patientData && wellnessDetails ? (
                                    <Graphs
                                        graphDetails={graphDetails}
                                        graphLoader={graphLoader}
                                        previousDay={previousDay}
                                        nextDay={nextDay}
                                        selectedDate={selectedDate}
                                        handleTodayClick={handleTodayClick}
                                        handleSelectDate={handleSelectDate}
                                        patientData={patientData}
                                        wellnessDetails={wellnessDetails}
                                        setStateLoading={setStateLoading}
                                        stateLoading={stateLoading}
                                    />
                                ) : (
                                    <div className="mt-6">
                                        <Emptyscreenwithouttitle
                                            FirstPTag={'No patient is currently associated with you.'}
                                            SecondePTag={'Please associate a patient to view the details.'}
                                            noPatientdashboardHeight={true}
                                        />

                                    </div>
                                ))
                            )}
                            {dashBoardTabName === "historical_data" && (patientData && wellnessDetails ? (
                                <HistoricalData 
                                setStateLoading={setStateLoading}
                                        stateLoading={stateLoading}
                                        />
                            ) : (
                                <div className="mt-6">
                                    <Emptyscreenwithouttitle
                                        FirstPTag={'No patient is currently associated with you.'}
                                        SecondePTag={'Please associate a patient to view the details.'}
                                        noPatientdashboardHeight={true}
                                    />
                                </div>
                            ))}
                        </div>

                    </motion.div>
                </div>
            </div>
        </>
    )
}